export function TabHeader({ label, maxValue, index }) {
  return (
    <th scope="col" id={`header-${index}`} className="border p-2 font-semibold">
      {label} {maxValue !== undefined && `/ ${maxValue}`}
    </th>
  );
}
